import { useMemo, useSyncExternalStore } from 'react'
import { useAppStore } from '@/stores/appStore'
import { companionEnabled, subscribeCompanion } from '@/lib/companion'

export function useCompanion() {
  const userId = useAppStore((s) => s.user?.id)
  const familyId = useAppStore((s) => s.familyId)
  const personId = useAppStore((s) => s.focusedPersonId)
  const status = useAppStore((s) => s.status)
  const needsConsent = useAppStore((s) => s.needsConsent)
  const actorName = useAppStore((s) => s.persons.find((p) => p.linked_user_id === s.user?.id)?.display_name
    ?? (typeof s.user?.user_metadata?.full_name === 'string' ? s.user.user_metadata.full_name : ''))
  const preference = useSyncExternalStore(subscribeCompanion,
    () => companionEnabled(userId, familyId), () => false)
  const enabled = preference && status === 'active' && !needsConsent
  const scope = useMemo(() => userId && familyId && personId ? { userId, familyId, personId } : null,
    [userId, familyId, personId])
  return { scope, enabled, preference, userId, familyId, actorName }
}
